(function($) {
    $.widget("ca.caMultiSelectOneLine", {
        _create : function() {
            $('.select-chosen').chosen({width: "100%", display_selected_options: false});
        }
    });
})(jQuery);